import { useRuntime } from "./useRuntime";
export var usePath = function() {
    var ref = useRuntime(), path = ref.page.path;
    return {
        isHomepage: /^index\.?/.test(path)
    };
};
